export interface Factory {
  id: string;
  name: string;
  description: string;
}

export interface ValueStream {
  id: string;
  name: string;
  factories: Factory[];
}

export const valueStreams: ValueStream[] = [
  {
    id: 'services',
    name: 'Services',
    factories: [
      {
        id: 'it',
        name: 'Département informatique',
        description: 'Services informatiques et support technique'
      },
      {
        id: 'electrical',
        name: 'Électrique/Automatisation',
        description: 'Services électriques et automatisation'
      },
      {
        id: 'construction',
        name: 'Construction',
        description: 'Services de construction et maintenance'
      },
      {
        id: 'garage',
        name: 'Garage',
        description: 'Services de maintenance des véhicules'
      },
      {
        id: 'shop911',
        name: 'Shop 911',
        description: 'Services d\'urgence et réparations'
      }
    ]
  },
  {
    id: 'combustible',
    name: 'VS Combustible',
    factories: [
      {
        id: 'boiler-sq',
        name: 'Boiler SQ',
        description: 'Unité de production de chaleur Saint-Quentin'
      },
      {
        id: 'boiler-kg',
        name: 'Boiler KG',
        description: 'Unité de production de chaleur Kedgwick'
      },
      {
        id: 'granules',
        name: 'Granules',
        description: 'Production de granules de bois'
      }
    ]
  },
  {
    id: 'approvisionnement',
    name: 'VS Approvisionnement',
    factories: [
      {
        id: 'scale',
        name: 'Scale',
        description: 'Centre de pesée et réception'
      },
      {
        id: 'cours',
        name: 'Cours',
        description: 'Gestion de la cour et des stocks'
      }
    ]
  },
  {
    id: 'composantes',
    name: 'VS Composantes',
    factories: [
      {
        id: 'composante-sq',
        name: 'Composante SQ',
        description: 'Production de composantes Saint-Quentin'
      },
      {
        id: 'composante-kg',
        name: 'Composante KG',
        description: 'Production de composantes Kedgwick'
      },
      {
        id: 'restigouche',
        name: 'Restigouche',
        description: 'Production de composantes Restigouche'
      }
    ]
  },
  {
    id: 'palettes',
    name: 'VS Palettes',
    factories: [
      {
        id: 'palettes',
        name: 'Palettes',
        description: 'Production principale de palettes'
      },
      {
        id: 'savoie',
        name: 'Savoie',
        description: 'Usine Savoie'
      },
      {
        id: 'westville',
        name: 'Westville',
        description: 'Site de production Westville'
      },
      {
        id: 'triage',
        name: 'Triage',
        description: 'Centre de triage'
      },
      {
        id: 'palettes-plus',
        name: 'Palettes Plus',
        description: 'Production spécialisée de palettes'
      }
    ]
  }
];

// Office factory definition
export const office: Factory = {
  id: 'office',
  name: 'Office',
  description: 'Bureau administratif de Groupe Savoie'
};

export const getAllFactories = (): Factory[] => {
  return [office, ...valueStreams.flatMap(vs => vs.factories)];
};

export const getFactoryById = (id: string): Factory | undefined => {
  if (id === 'office') return office;
  return valueStreams.flatMap(vs => vs.factories).find(factory => factory.id === id);
};

export const getValueStreamById = (id: string): ValueStream | undefined => {
  return valueStreams.find(vs => vs.id === id);
};

export const factoryList = getAllFactories();